/* eslint-disable react/no-unescaped-entities */
import { useState } from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}
const ImpactAccordion = ({ impactMilestones,index }) => {
  const [open, setOpen] = useState(1);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };
  var i = 0;

  return <div className="mb-7">
    <Accordion
      key={i}
      className="mb-5 overflow-hidden rounded-lg border border-jacarta-100 dark:border-jacarta-600"
      open={open === i}
      icon={<Icon id={i} open={open} />}
    >
      <AccordionHeader
        className="accordion-button relative flex w-full items-center justify-between bg-white px-4 py-3 text-left font-display text-jacarta-700 dark:bg-jacarta-700 dark:text-white text-md"
        onClick={() => handleOpen(i)}
      >
       <h2>KPI &#160;&#160;{index+1}</h2>
      </AccordionHeader>
      <AccordionBody className="accordion-body border-t border-jacarta-100 bg-white p-4 dark:border-jacarta-600 dark:bg-jacarta-700 h-full text-base">
        {impactMilestones}
      </AccordionBody>
    </Accordion>
  </div>;
};

export default ImpactAccordion;
